const manifestMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const manifestDatePattern = /^(\d{4})-(\d{2})-(\d{2})/;

export function formatManifestDate(value) {
    if (value === null || value === undefined || value === '') return '';

    const normalizedValue = String(value).trim();
    const dateParts = normalizedValue.match(manifestDatePattern);
    if (!dateParts) return normalizedValue;

    const year = dateParts[1];
    const month = manifestMonths[Number(dateParts[2]) - 1];
    const day = dateParts[3];
    if (!month) return normalizedValue;

    return `${day}-${month}-${year}`;
}
